let c1_choice = '';

class Simulation {
  constructor(el,opt){
    this.el = el;
    if($("." + this.el).length > 0){
      this.restoration();
      this.resultPrice();
      this.tabChangeEvent();
      this.choiceEvent();
      this.choiceEventbyou();
      this.choiceEventSenaka();
      this.choiceEventKashime();
      this.submitBtnActive();
      this.postalCodeSearch();
    }
  }

  submitBtnActive() {
    setInterval(() => {
      let flag = true;
      $('.js-choice-wrap button').each(function(){
        if($(this).hasClass('is-active') == false) {
          flag = false;
          return;
        }
      })
  
      if(!flag) {
        $('.js-submit-btn').prop('disabled', true).removeClass('is-active');
        $('.js-submit-caution').show();
      } else {
        $('.js-submit-btn').prop('disabled', false).addClass('is-active');
        $('.js-submit-caution').hide();
      }
    }, 500);
  }

  // 背中タブ: 溝あり/なし と 色の両方が選ばれているときだけ is-active
  updateSenakaTabActive() {
    const params = this.getParams();
    const hasMizo = params['c6-radio'] !== undefined && params['c6-radio'] !== '';
    const hasColor = params['c6'] !== undefined && params['c6'] !== '';
    const $tab = $('.js-choice-wrap button[data-id="c6"]');

    if(hasMizo && hasColor) {
      $tab.addClass('is-active');
    } else {
      $tab.removeClass('is-active');
    }
  }

  choiceEvent(){
    // preserve "this" for use inside callback
    const self = this;
    $('.js-choice').each(function(){
      const id = $(this).attr('data-id');
      const price = $(this).attr('data-price');

      let $choiceBtns = $(this).find('.js-choice-btn');
      $choiceBtns.each(function(index){
        $(this).on('click', function(){

          // use the correct "this" (Simulation instance) via 'self'
          self.url(id, index);
          self.resultPrice();
          self.restoration();

          if (id === 'c10') {
            const type = $(this).data('type');
            self.changeEdgeMask(type);
          }
        });
      });
    });
  }

  choiceEventSenaka() {
      
    // preserve "this" for use inside callback
    const self = this;

    const params = this.getParams();

    if(params['c6-radio'] && params['c6-radio'] !== '') {
      $('[data-id="c6-radio"] input').eq(params['c6-radio']).prop('checked', true);
      if(params['c6-radio'] === '1') {
        $('.js-groove-off').show();
        $('.js-grooved-light').hide();
      } else {
        $('.js-groove-off').hide();
        $('.js-grooved-light').show();
      }

      self.choiceEventSenakaResult();
    }

    if(params['c6'] && params['c6'] !== '') {
      const id = $('.js-choice-senaka').attr('data-id');

      const $el = $('.js-choice-senaka .js-choice-btn').eq(params['c6']);

      // 共通メソッドを使用してスタイルを適用
      const $target = $(`#${id}`);
      const color = $el.attr('data-color') ? $el.attr('data-color') : 'none';
      const mixBlendMode = $el.attr('data-mix-blend-mode') ? $el.attr('data-mix-blend-mode') : 'inherit';
      const img = $el.attr('data-img') ? `url(${$el.attr('data-img')})` : 'none';

      if (color) $target.css('background-color', color);
      if (mixBlendMode) $target.css('mix-blend-mode', mixBlendMode);
      if (img) $target.css('background-image', img);

      if (id === 'c1') c1_choice = $el.find('p').text();

      $el.addClass('is-choice');
      $el.siblings().removeClass('is-choice');

      self.choiceEventSenakaResult();
    }

    // 溝・色の両方が揃っているときだけタブをアクティブに
    self.updateSenakaTabActive();

    $('.js-choice-senaka').each(function(){
      $(this).find('.js-choice-radio').on('click', function(){
        const id = $(this).attr('data-id');
        $(this).data('off') ? $('.js-groove-off').show() : $('.js-groove-off').hide();
        $(this).data('off') ? $('.js-grooved-light').hide() : $('.js-grooved-light').show();
        $(this).data('off') ? $('.js-no-grooved').show() : $('.js-no-grooved').hide();
        self.url(id, $(this).index());
        self.updateSenakaTabActive();
        self.choiceEventSenakaResult();
      });

      const id = $(this).attr('data-id');
      const price = $(this).attr('data-price');

      let $choiceBtns = $(this).find('.js-choice-btn');
      $choiceBtns.each(function(index){
        $(this).on('click', function(){
          // 共通メソッドを使用してスタイルを適用
          const $target = $(`#${id}`);
          const color = $(this).attr('data-color') ? $(this).attr('data-color') : 'none';
          const mixBlendMode = $(this).attr('data-mix-blend-mode') ? $(this).attr('data-mix-blend-mode') : 'inherit';
          const img = $(this).attr('data-img') ? `url(${$(this).attr('data-img')})` : 'none';
    
          if (color) $target.css('background-color', color);
          if (mixBlendMode) $target.css('mix-blend-mode', mixBlendMode);
          if (img) $target.css('background-image', img);
    
          if (id === 'c1') c1_choice = $(this).find('p').text();
    
          // ボタンの状態を更新
          if($(this).hasClass('radiobox')) {
            $(this).find('input').prop('checked', true);
          } else {
            $(this).addClass('is-choice');
            $(this).siblings().removeClass('is-choice');
          }
    
          // use the correct "this" (Simulation instance) via 'self'
          self.url(id, index);
          self.updateSenakaTabActive();
          self.resultPrice();
          self.restoration();
          self.choiceEventSenakaResult();
        });
      });
    });
  }

  replaceMaskImageFile($target, newFile) {
    let maskImage =
      $target.css('mask-image') || $target.css('-webkit-mask-image');
  
    if (!maskImage || maskImage === 'none') return;
  
    let currentUrl = maskImage
      .replace(/^url\(["']?/, '')
      .replace(/["']?\)$/, '');
  
    let newUrl = currentUrl.replace(/[^/]+$/, newFile);
  
    $target.css({
      'mask-image': `url("${newUrl}")`,
      '-webkit-mask-image': `url("${newUrl}")`
    });
  }

  changeEdgeMask(type) {
    if (type === 'heart') {
      this.replaceMaskImageFile($('#c5'), 'edge_black_heart.png');
      this.replaceMaskImageFile($('#c4'), 'separator_black_heart.png');
    } else {
      this.replaceMaskImageFile($('#c5'), 'edge_black.png');
      this.replaceMaskImageFile($('#c4'), 'separator_black.png');
    }
    this.setShapeParam('c10_shape', type);
  }

  toggleByouDefault($btn) {
    const img = $btn.attr('data-img') || '';
  
    // c12がノーマル（byou-img01.png）なら非表示
    // それ以外が選ばれたら表示
    if (img.includes('byou-img01.png')) {
      $('#c2-byou').css('opacity', 0);
    } else {
      $('#c2-byou').css('opacity', 1);
    }
  }

  setShapeParam(key, value) {
    if (this.isRestoring) return;
  
    const url = new URL(window.location.href);
    url.searchParams.set(key, value);
    window.history.replaceState({}, '', url);
  }
  
  choiceEventSenakaResult() {
    const params = this.getParams();
    const mizoTxt = `[${$('.js-choice-radio').eq(params['c6-radio']).find('.js-resultTxt').text()}]`;
    const colorTxt = mizoTxt + `${$('.js-choice-senaka .js-choice-btn').eq(params['c6']).find('.js-resultTxt').text()}`;

    $('.js-choice-result[data-id="c6"]').text(colorTxt);
  }

  choiceEventKashime() {
    // preserve "this" for use inside callback
    const self = this;

    const params = this.getParams();

    $('.js-choice-kashime').each(function(){

      const id = $(this).attr('data-id');
      const price = $(this).attr('data-price');

      $(this).find('.js-kanagu').on('click', function(){

        const correspondence = $(this).data('correspondence');

        $('.js-kashime').each(function(){
          if($(this).data('correspondence') === correspondence) {
            $(this).animate({opacity: 1}, 100);
            $(this).css('pointer-events', 'auto');
            if(correspondence != 'various-color') {
              $('.js-kashime-txt').hide();
              $(this).trigger('click');
            } else {
              $('.js-kashime-txt').show();
              $('.js-kashime[data-correspondence="various-color"]').eq(0).trigger('click');
            }
          } else {
            $(this).removeClass('is-choice');
            $(this).animate({opacity: 0.5}, 100);
            $(this).css('pointer-events', 'none');
          }
        });

        const radioId = $(this).attr('data-id');
        self.url(radioId, $(this).index());

        let img = $(this).attr('data-img') ? `url(${$(this).attr('data-img')})` : 'none';
        
        let $target = $(`#${id}`);
        if (img) $target.css('background-image', img);

        $('.js-kanagu').each(function(){
          // $(this)のどれかがcheckedなら
          if ($(this).find('input').is(':checked')) {
            $('.js-choice-wrap button[data-id="c11"]').addClass('is-active');
          }
        });

        self.choiceEventKashimeResult();
      });

      let $choiceBtns = $(this).find('.js-kashime-choice-btn');

      $choiceBtns.find('.js-kashime').each(function(index){
        $(this).on('click', function(){
          $('.js-kashime').removeClass('is-choice');
          $(this).addClass('is-choice');

          // use the correct "this" (Simulation instance) via 'self'
          self.url(id, index);
          self.resultPrice();
          self.restoration();

          const correspondence = $(this).data('correspondence');

          $('.js-kashime').each(function(){
            if($(this).data('correspondence') === correspondence) {
              $(this).animate({opacity: 1}, 100);
              $(this).css('pointer-events', 'auto');
            } else {
              $(this).animate({opacity: 0.5}, 100);
              $(this).css('pointer-events', 'none');
            }
          });

          $('.js-kanagu').each(function(){
            if($(this).data('correspondence') === correspondence) {
              $(this).find('input').prop('checked', true);
            }
          });

          self.choiceEventKashimeResult();
        });
      });

      // ゴールド・真鍮黒の場合、背カンを「立ち上がり」に変更
      $('.js-kanagu, .js-kashime').on('click', function(){
        changeTachiagari($(this).data('correspondence'));
      });
    });

    if(params['c11'] && params['c11'] !== '') {
      const $btn = $('.js-choice-btn.js-kashime').eq(params['c11']);
      const correspondence = $btn.data('correspondence');
      $btn.addClass('is-choice');

      $('.js-kashime').each(function(){
        if($(this).data('correspondence') === correspondence) {
          $(this).animate({opacity: 1}, 100);
          $(this).css('pointer-events', 'auto');
        } else {
          $(this).animate({opacity: 0.5}, 100);
          $(this).css('pointer-events', 'none');
        }
      });
      self.choiceEventKashimeResult();
      
      changeTachiagari($btn.data('correspondence'));
    }

    if(params['c11-radio'] && params['c11-radio'] !== '') {
      $('[data-id="c11-radio"] input').eq(params['c11-radio']).prop('checked', true);
      const $radio = $('[data-id="c11-radio"]').eq(params['c11-radio']);
      const id = $('.js-choice-kashime').data('id');
      const img = $radio.attr('data-img') ? `url(${$radio.attr('data-img')})` : 'none';

      const $target = $(`#${id}`);
      
      if (img) $target.css('background-image', img);

      $('.js-choice-wrap button[data-id="c11"]').addClass('is-active');

      self.choiceEventKashimeResult();

      changeTachiagari($radio.data('correspondence'));
    }

    function changeTachiagari(correspondence) {
      if(correspondence === 'gold-color' || correspondence === 'shinchu-color') {
        $('.js-choice-btn.js-tachiagari').trigger('click');
        $('.js-sekan-caution').css('display', 'none');
        $('.js-choice-btn.js-tachiagari').siblings().animate({opacity: 0.5}, 300);
        $('.js-choice-btn.js-tachiagari').siblings().css('pointer-events', 'none');
      } else {
        $('.js-sekan-caution').css('display', 'block');
        $('.js-choice-btn.js-tachiagari').siblings().animate({opacity: 1}, 300);
        $('.js-choice-btn.js-tachiagari').siblings().css('pointer-events', 'auto');
      }
    }
  }

  choiceEventKashimeResult() {
    const params = this.getParams();
    const kanaguTxt = $('.js-kanagu').eq(params['c11-radio']).length > 0 ? `${$('.js-kanagu').eq(params['c11-radio']).find('.js-resultTxt').text()}` : '未選択';
    const kanaguPrice = $('.js-kanagu').eq(params['c11-radio']).length > 0 ? $('.js-kanagu').eq(params['c11-radio']).data('price') : '0';

    $('.js-individual-price[data-id="c11-radio"]').attr('data-price', kanaguPrice);
    $('.js-choice-result[data-id="c11-radio"]').text(kanaguTxt);
    $('.js-individual-price[data-id="c11-radio"]').text(`+${kanaguPrice.toLocaleString()}円`);

    const kashimeTxt = $('.js-kashime').eq(params['c11']).length > 0 ? `${$('.js-kashime').eq(params['c11']).find('.js-resultTxt').text()}` : '未選択';
    $('.js-choice-result[data-id="c11"]').text(kashimeTxt);

    const basePrice = Number($('.js-total-price').attr('data-base-price'));
    
    let totalPrice = basePrice;

    $('.js-individual-price').each(function(){
      const price = Number($(this).attr('data-price') || 0);
      totalPrice += price;
    });

    $('.js-total-price').text(`${totalPrice.toLocaleString()}`);
  }

  choiceEventbyou() {
    const self = this;
  
    $('.js-choice[data-id="c12"]').each(function(){
      $(this).find('.js-choice-btn').each(function(){
        $(this).on('click', function(){
          $('.js-choice[data-id="c12"] .js-choice-btn').removeClass('is-choice');
          $(this).addClass('is-choice');
  
          self.toggleByouDefault($(this));
        });
      });
    });
  }
  tabChangeEvent() {
    const self = this;

    $('.js-choice-wrap button').on('click', function(){
      let el = $(this);
      let choiceId = $(this).attr('data-id');
      
      self.tabChangeFunction(el, choiceId);
    });

    $('.js-prev-next-btn').on('click', function(){
      let el = $(`.js-choice-wrap button[data-id="${$(this).attr('data-id')}"]`);
      let choiceId = $(this).attr('data-id');

      self.tabChangeFunction(el, choiceId);
    });
  }

  tabChangeFunction(el, choiceId) {
    el.siblings().removeClass('is-choice');
    el.addClass('is-choice');

    $('.js-overview[data-id="' + choiceId + '"], .js-choice[data-id="' + choiceId + '"], .js-choice-senaka[data-id="' + choiceId + '"], .js-choice-kashime[data-id="' + choiceId + '"]').show();
    $('.js-overview[data-id!="' + choiceId + '"], .js-choice[data-id!="' + choiceId + '"], .js-choice-senaka[data-id!="' + choiceId + '"], .js-choice-kashime[data-id!="' + choiceId + '"]').hide();
  }

  // 選択されたボタンのスタイルを適用し、状態を更新する共通メソッド
  applyChoiceStyle(id, $btn, updateTab = false) {
    // $btnが存在しない場合は処理をスキップ
    if(!$btn || $btn.length === 0) {
      return;
    }
    
    if(id !== 'c11' && id !== 'c11-radio' && id !== 'c6' && id !== 'c6-radio') {
      const $target = $(`#${id}`);
      const color = $btn.attr('data-color') ? $btn.attr('data-color') : 'none';
      const mixBlendMode = $btn.attr('data-mix-blend-mode') ? $btn.attr('data-mix-blend-mode') : 'inherit';
      const img = $btn.attr('data-img') ? `url(${$btn.attr('data-img')})` : 'none';

      
      if (color) $target.css('background-color', color);
      if (mixBlendMode) $target.css('mix-blend-mode', mixBlendMode);
      if (img != 'none') {
        $target.css('background-image', img);
        $target.css('background-color', '');
        $target.css('mask-image', 'none');
      } else {
        $target.css('background-image', 'none');
        $target.css('mask-image', $target.attr('data-mask'));
      }

      if (id === 'c1') c1_choice = $btn.find('p').text();
      if (id === 'c2') {
        const $byouTarget = $('#c2-byou');
      
        if (img != 'none') {
          $byouTarget.css({
            'background-color': '',
            'background-image': 'none',
            'mask-image': $byouTarget.attr('data-mask'),
            '-webkit-mask-image': $byouTarget.attr('data-mask')
          });
        } else {
          $byouTarget.css({
            'background-color': color,
            'mix-blend-mode': mixBlendMode,
            'background-image': 'none',
            'mask-image': $byouTarget.attr('data-mask'),
            '-webkit-mask-image': $byouTarget.attr('data-mask')
          });
        }
      }

      // ボタンの状態を更新
      if($btn.hasClass('radiobox')) {
        $btn.find('input').prop('checked', true);
      } else {
        $btn.addClass('is-choice');
        $btn.siblings().removeClass('is-choice');
      }

      // タブをアクティブにする（オプション）
      if (updateTab) {
        $(`.js-choice-wrap button[data-id="${id}"]`).addClass('is-active');
      }
    }
  }

  // URLパラメータの追加・更新
  url(id, index) {
    const url = new URL(window.location.href);
    url.searchParams.set(id, index);
    window.history.replaceState({}, '', url);
    $('.js-url').val(url.toString());
  }
  // URLパラメータから分解(?c1=3&c2=5&c3=3 → {c1: 3, c2: 5, c3: 3})
  getParams() {
    const url = new URL(window.location.href);
    // URLのクエリパラメータをオブジェクト化
    const params = {};
    for (const [key, value] of url.searchParams.entries()) {
      params[key] = value;
    }
    return params;
  }
  // URLパラメータから更新・復活
  restoration() {
    const params = this.getParams();
    this.isRestoring = true;
    
    if(Object.keys(params).length > 0) {
      // paramsオブジェクトをfor文で繰り返してキーと値を出力
      for (const key in params) {
        if(key === 'price' || key === 'shape' || key === 'title' || key === 'submit' || key === 'c10_shape' || key === 'c6' || key === 'c6-radio' || key === 'c11' || key === 'c11-radio') {
          continue;
        }
        if (params.hasOwnProperty(key)) {
          const $choice = $(`.js-choice[data-id="${key}"]`);
          
          // $choiceが見つからない場合はスキップ
          if($choice.length === 0) {
            continue;
          }
          
          let $btn;
          $choice.find(`.js-choice-btn`).each(function(index){
            if(index === Number(params[key])) {
              $btn = $(this);
            }
          });
          
          // $btnが見つかった場合のみapplyChoiceStyleを呼び出す
          if($btn && $btn.length > 0) {
            // クリックイベントをトリガーせず、直接状態を更新（タブもアクティブにする）
            this.applyChoiceStyle(key, $btn, true);
          }
        }
      }
    }
    if (params.c10_shape) {
      this.changeEdgeMask(params.c10_shape);
    }
  
    this.isRestoring = false;
  }
  // 金額を計算
  price() {
    const params = this.getParams();

    // 背中(c6): js-choice-senaka のためここで個別に反映
    if (params['c6'] !== undefined && params['c6'] !== '') {
      const $target = $(`.js-individual-price[data-id="c6"]`);
      const $choice = $('.js-choice-senaka[data-id="c6"]');
      const price = Number($choice.attr('data-price') || 0);
      $target.attr('data-price', price);
      $target.text(`+${price.toLocaleString()}円`);
    }

    if(Object.keys(params).length > 0) {
      for (const key in params) {
        if(key === 'price' || key === 'shape' || key === 'title' || key === 'submit' || key === 'c10_shape' || key === 'c6' || key === 'c6-radio' || key === 'c11' || key === 'c11-radio') {
          continue;
        }
        if (params.hasOwnProperty(key)) {
          const $choice = $(`.js-choice[data-id="${key}"]`);
          const $target = $(`.js-individual-price[data-id="${key}"]`);
          
          // c2〜c5までは、本体の色(c1)と同じ名前だったら0円（番号ではなく名前で比較）
          if (/^c[2-5]$/.test(key)) {
            const norm = (t) => (t || '').replace(/\s+/g, '').trim();
            const c1Name = norm($('.js-choice[data-id="c1"]').find('.js-choice-btn').eq(Number(params['c1'])).find('.js-resultTxt').text());
            const keyName = norm($choice.find('.js-choice-btn').eq(Number(params[key])).find('.js-resultTxt').text());
            if (c1Name !== '' && keyName !== '' && keyName === c1Name) {
              $target.attr('data-price', 0);
            } else {
              $target.attr('data-price', $choice.attr('data-price'));
            }
          } else {
            // c2〜c5以外の場合、初期値として$choiceのdata-priceを設定
            $target.attr('data-price', $choice.attr('data-price') || 0);
          }
          // 〆c2〜c5までは、c1と同じ数字だったら0円

          // 個別の.js-choice-btnにdata-priceがあればそれを使用
          const index = Number(params[key]);
          const individualPrice = $choice.find('.js-choice-btn').eq(index).attr('data-price');
          if(individualPrice) {
            $target.attr('data-price', individualPrice);
          }
          // 〆個別の.js-choice-btnにdata-priceがあればそれを使用

          const price = Number($target.attr('data-price') || 0);
          $target.text(`+${price.toLocaleString()}円`);
        }
      }
    }


    if($('.js-choice-result[data-id="c11"]').text() == 'ゴールド' || $('.js-choice-result[data-id="c11"]').text() == '真鍮黒') {
      $('.js-individual-price[data-id="c13"]').attr('data-price', 0);
      $('.js-individual-price[data-id="c13"]').text('+0円');
    }

    const basePrice = Number($('.js-total-price').attr('data-base-price'));
    
    let totalPrice = basePrice;

    $('.js-individual-price').each(function(){
      const price = Number($(this).attr('data-price') || 0);
      totalPrice += price;
    });

    $('.js-total-price').text(`${totalPrice.toLocaleString()}`);
  }
  // 選んだ色・装飾をご注文内容に反映
  result() {
    const params = this.getParams();

    if(Object.keys(params).length > 0) {
      for (const key in params) {
        if(key === 'price' || key === 'shape' || key === 'title' || key === 'submit' || key === 'c10_shape' || key === 'c6' || key === 'c6-radio' || key === 'c11' || key === 'c11-radio') {
          continue;
        }

        if (params.hasOwnProperty(key)) {
          const $choice = $(`.js-choice[data-id="${key}"]`);
          const $result = $(`.js-choice-result[data-id="${key}"]`);
          
          $result.text($choice.find('.js-resultTxt').eq(params[key]).text());
        }
      }
    }
  }
  resultPrice() {
    this.price();
    this.result();
  }

  // 郵便番号検索機能
  postalCodeSearch() {
    const $postalCodeInput = $('.p-postal-code');
    const $addressInput = $('.p-region');

    if ($postalCodeInput.length === 0 || $addressInput.length === 0) {
      return;
    }

    $postalCodeInput.on('blur', function() {
      const postalCode = $(this).val().replace(/[^\d]/g, '');
      
      // 郵便番号が7桁の場合のみ検索
      if (postalCode.length === 7) {
        $.ajax({
          url: 'https://zipcloud.ibsnet.co.jp/api/search',
          type: 'GET',
          dataType: 'json',
          data: {
            zipcode: postalCode
          },
          success: function(data) {
            if (data.results && data.results.length > 0) {
              const result = data.results[0];
              const address = result.address1 + result.address2 + (result.address3 || '');
              $addressInput.val(address);
            } else {
              console.log('該当する住所が見つかりませんでした');
            }
          },
          error: function() {
            console.log('郵便番号検索でエラーが発生しました');
          }
        });
      }
    });
  }
}
